module.exports = __webpack_public_path__ + "img/library-button.b457f78a.svg";